import "./Connect.module.css";
import Header from "@/reusable_sections/Header";
import PartnerWithJadav from "./sections/PartnerWithJadav";
import OurStores from "./sections/OurStores";
import Footer from "@/reusable_sections/Footer";
export default function ConnectPage() {
  return <div>
      <Header />
      <PartnerWithJadav />
      <OurStores />
      <Footer />
    </div>;
}